const PAGE_INDEX = 'Index'
const PAGE_VIDEOS = 'Videos'
const PAGE_REFERENCES = 'References'
const PAGE_TAKE_QUESTION = 'TakeQuestion'
const PAGE_EXAMPLES = 'Examples'
const PAGE_RESET = 'Reset'
const PAGE_LOGIN = 'Login'
const PAGE_ACTIVATION = 'Activation'
const PAGE_PAYMENT_SUCCESS = 'PaymentSuccess'
const PAGE_PAYMENT_ERROR = 'PaymentError'
const PAGE_SHARE = 'SharePage'
const PAGE_PRIVACY = 'PrivacyPage'
const PAGE_FORBIDDEN = 'Forbidden'
const PAGE_COURSE_NOT_FOUND = 'CourseNotFound'

export {
  PAGE_INDEX,
  PAGE_VIDEOS,
  PAGE_REFERENCES,
  PAGE_TAKE_QUESTION,
  PAGE_EXAMPLES,
  PAGE_RESET,
  PAGE_LOGIN,
  PAGE_ACTIVATION,
  PAGE_PAYMENT_SUCCESS,
  PAGE_PAYMENT_ERROR,
  PAGE_SHARE,
  PAGE_PRIVACY,
  PAGE_FORBIDDEN,
  PAGE_COURSE_NOT_FOUND,
}



// WEBPACK FOOTER //
// ./client/student/router/routeNames.js